module.exports = __webpack_public_path__ + "img/15_DSC8200.386dd381.jpg";